"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._setInputs = _setInputs;
exports.setInputs = _setInputs3;
exports.resetInputs = _resetInputs;
exports.validateInputs = _validateInputs;
exports.setValues = _setValues;
exports.setErrors = _setErrors;
exports.updateAndValidate = _updateAndValidate;
exports.initializeInputs = _initializeInputs;
exports.bindActions = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _pick2 = _interopRequireDefault(require("lodash/pick"));

var _assign2 = _interopRequireDefault(require("lodash/assign"));

var _reduce2 = _interopRequireDefault(require("lodash/reduce"));

var _forEach2 = _interopRequireDefault(require("lodash/forEach"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _keys2 = _interopRequireDefault(require("lodash/keys"));

var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));

var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));

var _actionTypes = require("./actionTypes");

var _helpers = require("../util/helpers");

var _mountPoint = require("../util/mountPoint");

var _log = _interopRequireDefault(require("../util/log"));

var _reducers = require("../reducers");

var _promiseCache = {};

function _filterUnknownInputs(inputConfig, inputs) {
  // Only update known inputs
  return (0, _reduce2.default)(inputs, function (result, value, key) {
    if (!inputConfig[key]) {
      _log.default.error(key + ' is not a valid input.');
    } else {
      result[key] = value;
    }

    return result;
  }, {});
}
/**
 * Normalize an input state object removing unnecessary properties
 *
 * @private
 * @param input {Object}
 * @returns {Object}
 */


function _normalizeInput(input) {
  var normalized = (0, _objectSpread2.default)({}, input); // Remove validating key if falsey

  if (!normalized.validating) {
    delete normalized.validating;
  }

  return normalized;
}
/**
 * Normalize all input states
 *
 * @private
 * @param inputs {Object}
 * @return {Object}
 */


function _normalizeInputs(inputs) {
  return (0, _mapValues2.default)(inputs, _normalizeInput);
}

function _setInputs(inputConfig, update) {
  var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return {
    type: _actionTypes.SET_INPUT,
    payload: update,
    error: !!(0, _helpers.inputsWithErrors)(update),
    meta: (0, _objectSpread2.default)({
      reduxMountPoint: (0, _mountPoint.getReduxMountPoint)(inputConfig)
    }, meta)
  };
}

function _fireChanges(inputConfig, update, inputsState, state, dispatch) {
  (0, _forEach2.default)(update, function (input, key) {
    var _ref = inputConfig[key] || {},
        onChange = _ref.onChange;

    if (onChange) {
      onChange(input, inputsState, state, dispatch);
    }
  });
}
/**
 * Sets inputs' states without validation
 *
 * Also fires onChange callbacks for changed inputs
 *
 * `update` example:
 *  {
 *      email: {
 *          value: 'asdf@asdf.com'
 *      }
 *  }
 */


function _setInputs3(inputConfig, update) {
  var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (dispatch, getState) {
    var filteredUpdate = _filterUnknownInputs(inputConfig, update);

    var normalizedUpdate = _normalizeInputs(filteredUpdate);

    dispatch(_setInputs(inputConfig, normalizedUpdate, meta));

    if (!meta.suppressChange) {
      var state = getState();
      var inputsState = (0, _helpers.getInputsFromState)(inputConfig, state);

      _fireChanges(inputConfig, normalizedUpdate, inputsState, state, dispatch);
    }

    return Promise.resolve(normalizedUpdate);
  };
}

function _resetInputs(inputConfig, inputKeys) {
  var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var update = (0, _reducers.getDefaultInputs)(inputConfig);
  return _setInputs3(inputConfig, inputKeys ? (0, _pick2.default)(update, inputKeys) : update, (0, _objectSpread2.default)({
    reset: true
  }, meta));
}
/**
 * Validates the current state of inputs corresponding to the given keys
 *
 * @param inputConfig
 * @param inputKeys {Array}
 * @returns {Thunk}
 */


function _validateInputs(inputConfig, inputKeys) {
  var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (dispatch, getState) {
    var inputsState = (0, _helpers.getInputsFromState)(inputConfig, getState());
    var keys = inputKeys || (0, _keys2.default)(inputsState);
    var inputsToValidate = (0, _reduce2.default)(keys, function (result, key) {
      var input = inputsState[key];

      if (inputConfig[key] && input) {
        result[key] = typeof input.error !== 'undefined' ? input.error : input.value;
      }

      return result;
    }, {});
    return _updateAndValidate(inputConfig, inputsToValidate, (0, _objectSpread2.default)({}, meta, {
      validate: true
    }))(dispatch, getState);
  };
}
/**
 * Shortcut for setting just the values of the given inputs.
 *
 * @param inputsConfig
 * @param newValues {Object} key-value pair of new values
 * @param meta {Object}
 * @returns {Thunk}
 */


function _setValues(inputsConfig) {
  var newValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (dispatch) {
    var update = (0, _mapValues2.default)(newValues, function (value) {
      return {
        value: value
      };
    });
    return dispatch(_setInputs3(inputsConfig, update, meta));
  };
}
/**
 * Add errors to the given inputKeys
 *
 * @param inputsConfig
 * @param inputKeys {Array}
 * @returns {Thunk}
 */


function _setErrors(inputsConfig) {
  var inputKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (dispatch, getState) {
    var inputsState = (0, _helpers.getInputsFromState)(inputsConfig, getState());
    var update = (0, _reduce2.default)(inputKeys, function (result, key) {
      // Keep the existing value and async validating state, overwrite
      // everything else.
      var input = (0, _pick2.default)(inputsState[key], ['value', 'validating']);
      result[key] = (0, _objectSpread2.default)({}, input, {
        error: typeof inputsState[key].value === 'undefined' ? '' : inputsState[key].value
      });
      return result;
    }, {});
    return dispatch(_setInputs3(inputsConfig, update, meta));
  };
}

function _updateAndValidate(inputConfig, update) {
  var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (dispatch, getState) {
    var inputs = _filterUnknownInputs(inputConfig, update);

    if ((0, _isEmpty2.default)(inputs)) {
      return Promise.resolve();
    }

    var state = getState();
    var inputsState = (0, _helpers.getInputsFromState)(inputConfig, state);
    var promises = [];

    var createNewState = function createNewState(newInputState) {
      return _normalizeInput(meta.initialize ? (0, _objectSpread2.default)({
        pristine: true
      }, newInputState) : newInputState);
    };

    var changes = (0, _reduce2.default)(inputs, function (result, value, key) {
      var validator = inputConfig[key].validator;

      var _ref2 = inputsState[key] || {},
          prev = _ref2.value,
          currentlyValidating = _ref2.validating;

      var unchanged = (0, _isEqual2.default)(prev, value);
      var cachedValidation = unchanged && currentlyValidating && _promiseCache[key];
      var validationResult = cachedValidation ? cachedValidation : validator ? validator(value, inputsState, state, dispatch) : true;
      var hasAsync = (0, _typeof2.default)(validationResult) === 'object' && !!validationResult.then;

      var dispatchAndReturnPromiseResult = function dispatchAndReturnPromiseResult(inputState) {
        return _setInputs3(inputConfig, (0, _defineProperty2.default)({}, key, createNewState(inputState)), meta)(dispatch, getState);
      };

      if (typeof validationResult === 'boolean' || typeof validationResult === 'string' || hasAsync || !validationResult) {
        // Or Promise
        var change = validationResult === true || hasAsync ? {
          // True or hasAsync, set value
          value: value,
          validating: currentlyValidating || hasAsync && !unchanged // Will be validating if async validator exists

        } : {
          // False returned, input invalid
          value: prev,
          error: typeof value === 'undefined' ? '' : value,
          validating: false
        }; // Add errorText if validator returned a string

        if (typeof validationResult === 'string') {
          change.errorText = validationResult;
        }

        var newState = createNewState(change); // Only fire setInputs on state that is different than current.
        // If the only difference in state is that pristine is missing from
        // the new state, then we should still consider this pristine.

        if (!(0, _isEqual2.default)(newState, inputsState[key]) && !(0, _isEqual2.default)((0, _objectSpread2.default)({}, newState, {
          pristine: true
        }), inputsState[key])) {
          result[key] = newState;
        }

        if (!change.validating) {
          promises.push(Promise.resolve((0, _defineProperty2.default)({}, key, newState)));
        } else {
          var resultPromise = cachedValidation ? cachedValidation : _promiseCache[key] = validationResult.then( // Passed validation
          function () {
            return dispatchAndReturnPromiseResult({
              value: value
            });
          }, // Failed validation
          function (errorText) {
            return dispatchAndReturnPromiseResult((0, _objectSpread2.default)({
              value: prev,
              error: typeof value === 'undefined' ? '' : value
            }, typeof errorText === 'string' ? {
              errorText: errorText
            } : {}));
          }); // Kick off async

          promises.push(resultPromise);
        }
      } else {
        _log.default.error("\n                Value returned from validator must be a\n                boolean representing valid/invalid, a string representing errorText, or a promise for performing async\n                validation. Got ".concat((0, _typeof2.default)(validationResult), " instead.\n            "));
      }

      return result;
    }, {});

    if (!(0, _isEmpty2.default)(changes)) {
      _setInputs3(inputConfig, changes, meta)(dispatch, getState);
    }

    return new Promise(function (resolve, reject) {
      Promise.all(promises).then(function (results) {
        var resultObject = _assign2.default.apply(void 0, [{}].concat((0, _toConsumableArray2.default)(results)));

        var erroredInputs = (0, _helpers.inputsWithErrors)(resultObject);

        if (erroredInputs) {
          reject(erroredInputs);
        } else {
          resolve(resultObject);
        }
      });
    });
  };
}

function _initializeInputs(inputconfig, update) {
  var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return _updateAndValidate(inputconfig, update, (0, _objectSpread2.default)({
    initialize: true
  }, meta));
}

var bindActions = function bindActions(inputConfig) {
  return {
    setInputs: function setInputs(update, meta) {
      return _setInputs3(inputConfig, update, meta);
    },
    updateAndValidate: function updateAndValidate(update, meta) {
      return _updateAndValidate(inputConfig, update, meta);
    },
    validateInputs: function validateInputs(inputKeys, meta) {
      return _validateInputs(inputConfig, inputKeys, meta);
    },
    setValues: function setValues(newValues, meta) {
      return _setValues(inputConfig, newValues, meta);
    },
    setErrors: function setErrors(inputKeys, meta) {
      return _setErrors(inputConfig, inputKeys, meta);
    },
    resetInputs: function resetInputs(inputKeys, meta) {
      return _resetInputs(inputConfig, inputKeys, meta);
    },
    initializeInputs: function initializeInputs(update, meta) {
      return _initializeInputs(inputConfig, update, meta);
    }
  };
};

exports.bindActions = bindActions;


//////////////////
// WEBPACK FOOTER
// ./~/redux-inputs/lib/actions/index.js
// module id = 341
// module chunks = 0